import api_fetch  from "../utils/api_fetch"
import { storageHandler } from '../utils/storage_handler';

const customerDashboardService = {
    getDashboardData: async (customerId) => {
    try {
        const response = await api_fetch.get(`/v1/customer-dashboard/${customerId}`, {
            "Authorization": `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", {});
        return await response.json();
    } catch (error) {
        console.error('Failed to fetch customer dashboard data:', error);
        throw error;
    }
    }
};

export default customerDashboardService;
